/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Bold_Fox_ApplyInputs */

const en_deep_bold_fox_apply = /** @type {(inputs: Deep_Bold_Fox_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const de_deep_bold_fox_apply = /** @type {(inputs: Deep_Bold_Fox_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwenden`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Deep_Bold_Fox_ApplyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_bold_fox_apply = /** @type {((inputs?: Deep_Bold_Fox_ApplyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Bold_Fox_ApplyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_bold_fox_apply(inputs)
	return de_deep_bold_fox_apply(inputs)
});